import {createSelector} from 'reselect'
import {isLicenseExpired, isLicenseViolated, loggedInUserCanManageLicenses, wasOtherProductEverIntegrated} from '../../../js/activeLicenseInfo/selectors'
import {canManageAccountsAndPermissions} from '../../../js/loggedInUser/selectors'
import {PRODUCT_SWITCHER_URL} from '../../../js/constants'

const getAddonsState = state => state.addons

export const isAddonsMenuShown = state => getAddonsState(state).isShown

export const isShowAtIntegrationAction = createSelector(
    isLicenseExpired,
    isLicenseViolated,
    loggedInUserCanManageLicenses,
    canManageAccountsAndPermissions,
    wasOtherProductEverIntegrated,
    (licenseExpired, licenseViolated, canManageLicense, manageAccountsAndPermission, wasOtherProductEverIntegrated) => {
        return PRODUCT_SWITCHER_URL
               || (!wasOtherProductEverIntegrated && (canManageLicense || manageAccountsAndPermission) && !licenseExpired && !licenseViolated)
               || (wasOtherProductEverIntegrated && canManageLicense)
    }
)



// WEBPACK FOOTER //
// ./web/actiplans/js/addons/selectors.js